module.exports = __webpack_public_path__ + "img/test.9abcca69.jpg";